import Http from "../engine/Http";
import { Identifiable } from "../model/Items";
import useAuthenticationHeader from "../security/AuthenticationHeader.hook";

export interface SpringMaterialCustomerPrice {
  material: Identifiable;
  unitPrice: number;
}

export const convertSpringPricesToMaterialIdIndexedArray = (prices: SpringMaterialCustomerPrice[]): SpringMaterialCustomerPrice[] => {
  const materialIdIndexedPricesArray: SpringMaterialCustomerPrice[] = [];
  prices.forEach(price => {
    materialIdIndexedPricesArray[price.material.id] = price;
  });
  return materialIdIndexedPricesArray;
};

const useSpringMaterialCustomerPriceApi = () => {
  const authenticationHeader = useAuthenticationHeader();

  const fetchSpringMaterialCustomerPrices = (customerId: number, priceListId: number) : Promise<SpringMaterialCustomerPrice[]> =>
    Http.get(`/api/customers/${customerId}/price-lists/${priceListId}/spring-material-prices`, [ authenticationHeader ]);

  return {
    fetchSpringMaterialCustomerPrices
  };
};

export default useSpringMaterialCustomerPriceApi;